export default __webpack_public_path__ + "static/media/Noteworthy-Lt.0eca5de4.ttf";